import React, { FC } from 'react'
import Close from '@pixel/assets/icons/Close'
import Dialog from '@pixel/core/Dialog'
import IconButton from '@pixel/core/IconButton'
import { styled, useMediaQuery } from '@pixel/core/styles'
import Typography from "@pixel/core/Typography";
import useFieldListUpdateQuery from "../hooks/useFieldListUpdateQuery";
import FieldListViewContainer from "./FieldListViewContainer";

const WrappedDialogTitle = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
}))

const FlexCenterDiv = styled('div')({
    display: 'flex',
    alignItems: 'center',
})

interface FieldListViewModalProps {
    open: boolean
    selectedFieldListId: number
    onClose: () => void
}

export const FieldListViewModal: FC<FieldListViewModalProps> = ({
    open,
    selectedFieldListId,
    onClose,
}) => {
    const matches = useMediaQuery('(max-width:700px)')

    const {
        data,
    } = useFieldListUpdateQuery({fieldListId: selectedFieldListId});


    if (!data) {
        return null
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={matches}
            sx={{
                position: 'absolute',
                right: 0,
                left: 'unset',
                minWidth: matches ? '100vw' : 700,
            }}
            scroll="paper"
            PaperProps={{
                sx: { margin: 0, height: '100%', width: '100%', maxHeight: 'unset', maxWidth: 'unset' }
            }}
        >
            <WrappedDialogTitle>
                <Typography variant="h1">{data?.name ?? ''}</Typography>
                <FlexCenterDiv>
                    <IconButton aria-label="Close Modal" onClick={onClose}>
                        <Close />
                    </IconButton>
                </FlexCenterDiv>
            </WrappedDialogTitle>
            <FieldListViewContainer selectedFieldList={data} onModalClose={onClose} />
        </Dialog>
    )
}

export default FieldListViewModal
